import MonsterDescription from "../monster/MonsterDescription";
import Sprite from "../sprite/Sprite";
import CharacterBrain from "./brain/CharacterBrain";
import Character from "./Character";

export default class MonsterCharacter extends Character {
    constructor() {
        super();

        /**
         * @type {Sprite}
         */
        this.sprite = null;

        /**
         * @type {MonsterDescription}
         */
        this.monsterDescription = null;

        /**
         * @type {CharacterBrain}
         */
        this.brain = null;

        /**
         * @type {number}
         */
        this.damage = 1;
    }

    /**
     * @param {CharacterBrain} brain
     * @param {Sprite} sprite
     * @param {MonsterDescription} monsterDescription
     */
    set(brain, sprite, monsterDescription) {
        this.brain = brain;
        this.sprite = sprite;
        this.monsterDescription = monsterDescription;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isMonster() {
        return true;
    }

    // /**
    //  * @override
    //  * @param {Character} character 
    //  * @returns {boolean}
    //  */
    // isEnemy(character) {
    //     return !character.isMonster();
    // }

    /**
     * @override
     * @returns {string}
     */
    getMonsterDescriptionId() {
        return this.monsterDescription.id;
    }

    /**
     * @returns {Sprite}
     */
    getCharacterSprite() {
        return this.sprite;
    }
    
    /**
     * @override
     * @returns {number}
     */
    getDamage() {
        return this.damage;
    }

    /**
     * @override
     */
    chooseTurn() {
        this.brain.chooseTurn(this);
    }

    /**
     * @param {boolean} finishedAndAvailable 
     */
    reset(finishedAndAvailable) {
        super.reset(finishedAndAvailable);

        if (this.finishedAndAvailable) {
            this.position.resetFull(); // This removes the character from the grid.
            this.resetTurnState();
            this.brain = null;
        }
    }

}